import classNames from 'classnames/bind';
import { Container, FooterNavigationMenu, DisclosureBlock, SocialLinks, OuroLogoWithTagline, Grid } from '@/components';
import styles from './Footer.module.scss';

let cx = classNames.bind(styles);

export function Footer({ siteDescription, menuItems, disclosures }) {
  const year = new Date().getFullYear();
	return (
		<footer id='footer' className={cx('footer')}>
			<section className={cx(['directory', 'bg-black'])}>
				<Container>
					<Grid colCount={2}>
						<div className={cx('left')}>
							<OuroLogoWithTagline className={cx(['tagline'])} tagline={siteDescription} />
						</div>
						<div className={cx('right')}>
              <p className={cx('copyright')}>©{year} Ouro, its affiliates, and subsidiaries, all rights reserved. All trademarks and service marks are properties of their respective owners. Referenced payment programs subject to their individual terms and conditions.</p>
              <p>Ouro Global, Inc., Nationwide Multistate Licensing System ("NMLS") ID 932678  <a target="_blank" href="https://www.netspend.com/help/licenses">www.netspend.com/help/licenses</a></p>
							<FooterNavigationMenu menuItems={menuItems} />
							<SocialLinks hideDesktop={false} />
						</div>
					</Grid>
				</Container>
			</section>
			<DisclosureBlock disclosures={disclosures} />
		</footer>
	);
}
